import React, { useState, useEffect } from "react";
import { ScrollMenu } from "react-horizontal-scrolling-menu";
import "./DisplayYoutube.css";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { useTranslation } from "react-i18next";
import enTranslations from "../../en.json";
import arTranslations from "../../ar.json";

import YouTubeIcon from "@mui/icons-material/YouTube";

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: enTranslations },
    ar: { translation: arTranslations },
  },
  lng: "en",
  fallbackLng: "en",
  interpolation: { escapeValue: false },
});

function DisplayYoutube(props) {
  const [videos, setVideos] = useState([]);

  const api = process.env.REACT_APP_YOUTUBE_API_KEY;
  const { t } = useTranslation();

  useEffect(() => {
    const fetchVideos = async () => {
      const response = await fetch(
        `https://www.googleapis.com/youtube/v3/search?part=snippet&channelId=UCODSq0lKNepUR-g_C2tv5HA&maxResults=10&order=viewCount&key=${api}`
      );
      const data = await response.json();
      setVideos(data.items.map((item) => item.id.videoId));
    };
    fetchVideos();
  }, []);

  return (
    <div className="container-youtube">
      <h1 className="title12">{t("youtubechannel")}</h1>
      <ScrollMenu>
        {videos.map((videoId) => (
          <div key={videoId}>
            <iframe
              height={300}
              src={`https://www.youtube.com/embed/${videoId}`}
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        ))}
      </ScrollMenu>
      <div style={{ textAlign: "center" }}>
        <props.PrincipaleButton
          href="https://www.youtube.com/@Financebdarija"
          startIcon={<YouTubeIcon />}
        >
          {t("seemore")}
        </props.PrincipaleButton>
      </div>
    </div>
  );
}

export default DisplayYoutube;
